import { useState } from "react";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/solid";
import "./EventNavBar.scss";
import { ViewPicker } from "./ViewPicker";

import {
  add,
  eachDayOfInterval,
  endOfMonth,
  startOfMonth,
  startOfWeek,
  endOfWeek,
  format,
  getDay,
  isEqual,
  isSameDay,
  isSameMonth,
  isToday,
  parse,
  parseISO,
  startOfToday,
} from "date-fns";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const EventNavBarCalendar = (props) => {

  const [view, setView] = useState("List");

  function onFilterValueChanged(event) {
    props.filterValueSelected(event.target.value);
  }

  function onFilterValueTwoChanged(eventTwo) {
    props.filterValueTwoSelected(eventTwo.target.value);
  }

  const onViewValueChanged = (viewValue) => {
    setView(viewValue);
    props.viewValueSelected(viewValue); // Pass the selected view value to the parent component
  };

  function onClearFilters() {
    if (
      props.filterTextValue === "FILTER PROGRAM" &&
      props.filterTextValueTwo === "FILTER INSTRUMENT"
    ) {
      // Do nothing if both filters are set to their default values
      return;
    }
    // Implement logic to clear filters
    props.filterValueSelected("FILTER PROGRAM");
    props.filterValueTwoSelected("FILTER INSTRUMENT");
    // Check if both filters are set to their default values
  }

  const formatDate = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
    const month = dateObj.toLocaleDateString("en-US", { month: "long" });
    const dateNumber = dateObj.getDate();
    const time = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });

    return `${month} ${dateNumber} - ${time}`;
  };

  const getTimeNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
  };

  let today = startOfToday();
  let [selectedDay, setSelectedDay] = useState(today);
  let [currentMonth, setCurrentMonth] = useState(format(today, "MMM-yyyy"));
  let firstDayCurrentMonth = parse(currentMonth, "MMM-yyyy", new Date());

  let days = eachDayOfInterval({
    start: startOfWeek(firstDayCurrentMonth),
    end: endOfWeek(endOfMonth(firstDayCurrentMonth)),
  });

  function previousMonth() {
    let firstDayNextMonth = add(firstDayCurrentMonth, { months: -1 });
    setCurrentMonth(format(firstDayNextMonth, "MMM-yyyy"));
    props.previousMonth();
  }

  function nextMonth() {
    let firstDayNextMonth = add(firstDayCurrentMonth, { months: 1 });
    setCurrentMonth(format(firstDayNextMonth, "MMM-yyyy"));
    props.nextMonth();
  }

  function currentMonthFunction() {
    let firstDayNextMonth = add(firstDayCurrentMonth, { months: 1 });
    setCurrentMonth(format(today, "MMM-yyyy"));
    props.currentMonthFunction();
  }

  const isEventFromPreviousMonth = (eventDate) => {
    return !isSameMonth(
      parseISO(eventDate),
      parse(currentMonth, "yyyy-MM", new Date())
    );
  };

  const showFilterSection = props.viewValue !== "List";

  return (
    <>
      <div className="h-full md:hidden pb-4">
        <ViewPicker onViewValueChanged={onViewValueChanged} onFilterValueChanged={onFilterValueChanged} onFilterValueTwoChanged={onFilterValueTwoChanged} />
      </div>
      <div className="flex flex-auto flex-col md:flex-row">
        <div className="flex-grow mb-4 md:mb-0 md:mr-4">
          <div className="">
            {showFilterSection && (
              <div className="h-full">
                <div className="flex flex-auto gap-5 content-stretch">
                  <div className="justify-items-center" id="cFilter">
                    <div className="flex items-center text-white">
                      <button
                        type="button"
                        onClick={previousMonth}
                        className="flex flex-none items-center justify-center text-white-400"
                      >
                        <span className="sr-only">Previous month</span>
                        <ChevronLeftIcon
                          className="w-8 h-8"
                          aria-hidden="true"
                        />
                      </button>
                      <h2 className="flex-auto font-bold text-white-900 text-2xl sm:text-4xl" style={{
                        fontFamily: "Norwester, Poppins, sans-serif",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                      }}>
                        {format(firstDayCurrentMonth, "MMM yyyy").toUpperCase()}
                      </h2>
                      <button
                        onClick={nextMonth}
                        type="button"
                        className="flex flex-none items-center justify-center text-white-400"
                      >
                        <span className="sr-only">Next month</span>
                        <ChevronRightIcon
                          className="w-8 h-8"
                          aria-hidden="true"
                        />
                      </button>
                     
                    </div>
                  </div>
                  <div className="justify-items-center" id="cFilter">

                  </div>
                </div>

              </div>
            )}
          </div>
        </div>
        <div className="h-full hidden md:flex">
          <ViewPicker onViewValueChanged={onViewValueChanged} onFilterValueChanged={onFilterValueChanged} onFilterValueTwoChanged={onFilterValueTwoChanged} />
        </div>
      </div>
    </>
  );
};
